import { observer } from 'mobx-react-lite'

import { EventIcon, TextArea } from 'components'
import { useValueContext } from 'contexts'
import { FlexLayout } from 'layouts'

import { TimeInputs, Volume } from '../../components'
import { iconProps } from '../consts'
import './styles.scss'

export const Pee = observer(() => {
  const { eventStore } = useValueContext()
  const { event, setEventField } = eventStore

  return (
    <>
      <div className="page-title event-title">Пи-пи</div>

      <FlexLayout.Content className="scrollable-layout event-scrollable" scrollable>
        <div className="pee-event">
          <div className="type-icons">
            <EventIcon iconName="PeeIcon" {...iconProps} />
          </div>
          <div className="pee-form">
            <TimeInputs
              label="Время"
              value={event?.startTime}
              onChange={(value: string) => setEventField('startTime', value)}
              eventType="START"
            />
            <Volume
              step={10}
              value={event?.volume || 0}
              onChange={(value: string | number) => setEventField('volume', value)}
              scrollToOnFocus
            />
            <TextArea
              className="event-textarea"
              label="Комментарий"
              value={event?.comment}
              onChange={(value: string) => setEventField('comment', value)}
              scrollToOnFocus
            />
          </div>
        </div>
      </FlexLayout.Content>
    </>
  )
})
